"use client";
import React, { useEffect, useRef, useState } from "react";
import { CaretCircleRight } from "@phosphor-icons/react";
import { useTranslations } from "next-intl";

const CoreValues = () => {
	const [isVisible, setIsVisible] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0];
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect(); // 动画触发后停止观察
				}
			},
			{
				root: null, // 使用浏览器视窗为根
				threshold: 0.1, // 当元素 10% 可见时触发
				rootMargin: "0px 0px -100px 0px", // 在元素离开视口100px前触发
			},
		);

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref.current) {
				observer.unobserve(ref.current);
			}
		};
	}, []);

	return (
		<div className="bg-gray-900 py-12">
			<div className="mb-8 text-center text-white">
				<h2 className="text-4xl font-bold">Core Values</h2>
			</div>
			<div
				ref={ref}
				className={`container grid grid-cols-1 gap-4 transition-opacity duration-1000 md:grid-cols-4 ${
					isVisible ? "animate__animated animate__fadeInUp" : "opacity-0"
				}`}
			>
				<div className="rounded-lg bg-white p-6 shadow-lg">
					<img src="/image/blog/1.png" alt="Quality" className="mb-4 h-40 w-full rounded-md object-cover" />
					<h3 className="mb-2 text-xl font-bold">Quality</h3>
					<p>
						We are committed to delivering products and services of the highest quality, ensuring precision
						and reliability in everything we do.
					</p>
				</div>
				<div className="rounded-lg bg-white p-6 shadow-lg">
					<img
						src="/image/blog/2.png"
						alt="Innovation"
						className="mb-4 h-40 w-full rounded-md object-cover"
					/>
					<h3 className="mb-2 text-xl font-bold">Innovation</h3>
					<p>
						We embrace new technologies and continuously seek innovative solutions to meet our clients'
						challenges.
					</p>
				</div>
				<div className="rounded-lg bg-white p-6 shadow-lg">
					<img
						src="/image/blog/3.png"
						alt="Customer Satisfaction"
						className="mb-4 h-40 w-full rounded-md object-cover"
					/>
					<h3 className="mb-2 text-xl font-bold">Customer Satisfaction</h3>
					<p>
						Our clients are at the heart of everything we do. We work closely with them to understand their
						needs and exceed their expectations.
					</p>
				</div>
				<div className="rounded-lg bg-white p-6 shadow-lg">
					<img src="/image/blog/4.png" alt="Integrity" className="mb-4 h-40 w-full rounded-md object-cover" />
					<h3 className="mb-2 text-xl font-bold">Integrity</h3>
					<p>
						We conduct our business with honesty and integrity, building trust with our clients and partners.
					</p>
				</div>
			</div>
		</div>
	);
};

const Core = () => {
	const t = useTranslations("about");
	const [acIndex, setAcIndex] = useState(0);
	const list = [
		{ img: "/image/about/检测02.png", title: t("core1T"), text: t("core1") },
		{ img: "/image/about/Create.png", title: t("core2T"), text: t("core2") },
		{ img: "/image/about/特色服务.png", title: t("core3T"), text: t("core3") },
		{ img: "/image/about/诚信.png", title: t("core4T"), text: t("core4") },
	];
	return (
		<div
			className=" h-[860px]  w-full bg-cover bg-no-repeat text-white max-md:h-fit  max-md:bg-center max-md:py-2"
			style={{ backgroundImage: "url('/image/about/4.png')" }}
		>
			<div className="container flex h-full flex-col justify-center">
				<h3 className="text-4xl font-bold ">{t("coreV")}</h3>
				<p className="my-5  w-20 border-b-2 border-b-white"></p>
				<p className="py-10 text-lg max-md:py-3">{list[acIndex].text}</p>
				<CaretCircleRight
					size={42}
					onClick={() => setAcIndex(acIndex === 3 ? 0 : acIndex + 1)}
					className="mb-10 cursor-pointer hover:text-main"
				/>

				<ul className="mt-5 grid grid-cols-4 gap-x-5 max-md:mt-1 max-md:grid-cols-2 max-md:gap-y-2">
					{list.map((item, index) => {
						return (
							<li
								key={index}
								className={`relative cursor-pointer rounded transition-all  ${
									acIndex === index ? "-translate-y-2" : "translate-y-0"
								}`}
								onClick={() => setAcIndex(index)}
							>
								<div
									className={`absolute left-0 top-0  flex h-full w-full  items-center justify-center bg-[#0071e3ad] text-lg font-bold transition-all  ${
										acIndex === index ? "absolute" : "hidden"
									}`}
								>
									<h4>{item.title}</h4>
								</div>
								<img src={item.img} alt={item.title} className="h-full w-full object-cover " />
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};
export default Core;
